export const getUniqueRequestsCreators = ({ requests, creators }) => {
  const creatorsMap = new Map();

  creators.forEach((c) => {
    if (c?.id && !creatorsMap.has(c.id)) {
      creatorsMap.set(c.id, c);
    }
  });

  requests.forEach((r) => {
    if (!r?.createUser?.id) {
      return;
    }
    if (creatorsMap.has(r.createUser.id)) {
      return;
    }
    creatorsMap.set(r.createUser.id, r.createUser);
  });

  return Array.from(creatorsMap.values()).sort((a, b) => a.id - b.id);
};
